import type { FieldValidationError } from "@/shared/types/workflow/workflow-form.types";
import type { FileUploadField } from "@spz/shared-domain";
import type { TFunction } from "i18next";

/**
 * Validates a file_upload field according to its validation constraints
 */
export function validateFileUpload({
  field,
  value,
  t,
}: {
  field: FileUploadField;
  value: File | undefined;
  t: TFunction;
}): FieldValidationError | undefined {
  if (!value || !field.validation) {
    return undefined;
  }

  const fileSizeMb = value.size / (1024 * 1024);

  if (
    field.validation.max_size_mb &&
    fileSizeMb > field.validation.max_size_mb
  ) {
    const max = field.validation.max_size_mb;
    return {
      translationKey: "workflow_validation_file_size",
      type: "max",
      params: { max },
      message: t("workflow_validation_file_size", { max }),
    };
  }

  if (
    field.validation.accepted_formats &&
    !field.validation.accepted_formats.includes(value.type)
  ) {
    return {
      translationKey: "workflow_validation_file_format",
      type: "format",
      message: t("workflow_validation_file_format"),
    };
  }

  return undefined;
}
